import React from 'react';
import moment from 'moment';

const Details = ({ data }) => {

  return <div className="row">
    <div className="col-lg-4">
      <ul className="list-group list-group-flush">
        <li className="list-group-item"><strong>Telehealth ID:</strong> {data.id}</li>

        {data.status === 'SCHEDULED' ?
          <li className="list-group-item"><strong>Pre-Visit Questions Available On:</strong><br /> {moment.tz(data.availableOn.date, data.availableOn.timezone).local().format('LL [at] LT')}</li>
          :
          (data.status === 'READY' || data.status === 'COMPLETED') ? <>
            {data.patientProfileId && data.completedAt &&
              <li className="list-group-item"><strong>Questions Completed On:</strong> {moment.tz(data.completedAt.date, data.completedAt.timezone).local().format('l LT')}</li>
            }
          </>
            :
            data.status === 'CANCELED' ?
              data.sentAt && <li className="list-group-item"><strong>Sent At:</strong> {moment.tz(data.sentAt.date, data.sentAt.timezone).local().format('l LT')}</li>
              :
              <li className="list-group-item">&nbsp;</li>
        }
      </ul>
    </div>
    <div className="col-lg-4">
      {data.status === 'CANCELED' ?
        <ul className="list-group list-group-flush">
          <li className="list-group-item"><strong>Canceled By:</strong> {data.canceledBy && `${data.canceledBy.firstName} ${data.canceledBy.lastName}`} </li>
          <li className="list-group-item"><strong>Canceled At:</strong> {data.canceledAt && moment.tz(data.canceledAt.date, data.canceledAt.timezone).local().format('l LT')}</li>
        </ul>
        :
        data.status !== 'SCHEDULED' ?
          <ul className="list-group list-group-flush">
            {data.status === 'READY' ?
              <li className="list-group-item">&nbsp;</li>
              :
              data.status === 'EXPIRED' ?
                <li className="list-group-item"><strong>Expired:</strong> {data.expiresAt && moment.tz(data.expiresAt.date, data.expiresAt.timezone).local().format('l LT')} </li>
                :
                !data.patientProfileId && !data.completedAt ?
                  <li className="list-group-item">Patient has not started.</li>
                  :
                  data.patientProfileId && !data.completedAt ?
                    <li className="list-group-item">Patient has started, but not completed pre-visit questions.</li>
                    :
                    data.uploadedAt &&
                    <li className="list-group-item"><strong>EHR Uploaded:</strong> {moment.tz(data.uploadedAt.date, data.uploadedAt.timezone).local().format('l LT')}</li>
            }
            {data.sentAt &&
              <li className="list-group-item"><strong>Sent At:</strong> {moment.tz(data.sentAt.date, data.sentAt.timezone).local().format('l LT')}</li>}
          </ul>
          :
          <ul className="list-group list-group-flush">
            <li className="list-group-item">&nbsp;</li>
            <li className="list-group-item">&nbsp;</li>
          </ul>
      }
    </div>
    <div className="col-lg-4">
      <ul className="list-group list-group-flush">
        <li className="list-group-item"><strong>Scheduled By:</strong> {data.scheduledBy ? `${data.scheduledBy.firstName} ${data.scheduledBy.lastName}` : 'EHR'}</li>
        <li className="list-group-item"><strong>Scheduled On:</strong> {moment.tz(data.scheduledAt.date, data.scheduledAt.timezone).local().format('l LT')}</li>
      </ul>
    </div>
  </div>
}

export default Details;